import { combineReducers } from 'redux';
import subsReducer from './apiReducer';
import authReducer from './authReducer';
import errorReducer from './errorReducer';
import unsubReducer from './unsubReducer';

const allReducers = (asyncReducers) =>
  combineReducers({
    errors: errorReducer,
    auth: authReducer,
    subs: subsReducer,
    unsubs: unsubReducer,
    ...asyncReducers,
  });

const rootReducer = () => allReducers();

export default rootReducer;
